import { Game } from '../game.model';
import { Player } from '../player.model';

export class Rejoined {
  game: Game;
  player: Player;
}
